import type { Work } from "@/types";

export const works: Work[] = [
  {
    id: "shadow-city",
    title: "暗影之城",
    titleEn: "Shadow City",
    type: "movie",
    region: "中国大陆",
    year: 2024,
    rating: 8.6,
    popularity: 9820,
    genres: ["悬疑", "犯罪", "剧情"],
    director: "顾长安",
    cast: ["陈默", "周雨桐", "李承峰", "许知远"],
    tagline: "每一盏熄掉的灯，都藏着一个不愿被记起的名字。",
    synopsis:
      "一场持续七天的暴雨让整座城市陷入断电，刑警林砚在追查连环失踪案时，发现所有线索都指向十五年前一桩被掩盖的旧案。",
    plot: [
      "暴雨围城的第七天，老城区又一次停电。刑警林砚接到报案，一名年轻记者在调查化工企业排污时失踪。随着排查深入，他惊讶地发现案发现场留下的标记，与十五年前那起已结案的工厂爆炸事件如出一辙。",
      "在记者苏晚留下的笔记本里，林砚拼凑出一张横跨两代人的关系网：当年被迫沉默的工人、如今身居高位的企业家，以及一个始终躲在暗处的“清道夫”。真相每推进一层，他离自己不愿面对的过去就更近一步。",
      "当最后一块拼图落下，林砚必须在职业操守与私人恩怨之间做出选择。影片以冷峻的镜头语言，讲述了一座城市如何与自己的阴影和解。",
    ],
    characters: [
      {
        name: "林砚",
        actor: "陈默",
        role: "刑警队长",
        description:
          "沉默寡言却极度执拗，习惯用脚步丈量每一处案发现场。父亲的意外身亡是他多年无法解开的结，也让他在追凶时带着近乎偏执的正义感。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20stoic%20male%20detective%20wearing%20a%20dark%20raincoat%2C%20moody%20blue%20lighting%2C%20rainy%20urban%20night%20background%2C%20professional%20film%20still%2C%20shallow%20depth%20of%20field%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-shadow-linyan&orientation=portrait"
      },
      {
        name: "苏晚",
        actor: "周雨桐",
        role: "调查记者",
        description:
          "敏锐而倔强的深度报道记者，为了真相可以连续蹲守数周。她的笔记本是撬动整起案件的关键，也是她留给世界最后的证词。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20determined%20young%20female%20investigative%20journalist%20holding%20a%20notebook%2C%20cool%20blue%20tones%2C%20city%20lights%20bokeh%20background%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-shadow-suwan&orientation=portrait"
      },
      {
        name: "郑巍",
        actor: "李承峰",
        role: "副局长",
        description:
          "经验老到、行事圆滑的上级，既是林砚的引路人，也是当年旧案的经办人之一。他始终相信有些真相需要时间来消化。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20seasoned%20senior%20police%20officer%20with%20grey%20temples%20in%20a%20dark%20uniform%2C%20low%20key%20lighting%2C%20office%20background%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-shadow-zhengwei&orientation=portrait"
      }
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20movie%20poster%20of%20a%20rainy%20neon%20city%20street%20at%20night%20with%20a%20lone%20detective%20silhouette%2C%20deep%20blue%20and%20orange%20color%20grading%2C%20moody%20atmosphere%2C%20dramatic%20shadows%2C%20professional%20film%20key%20art%2C%20high%20detail%2C%20vertical%20composition&width=600&height=900&seq=poster-shadow-city&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20rain%20soaked%20metropolis%20at%20night%20seen%20from%20a%20rooftop%2C%20deep%20blue%20tones%20with%20warm%20orange%20street%20glow%2C%20moody%20thriller%20atmosphere%2C%20professional%20film%20photography%2C%20high%20detail%2C%20horizontal%20composition&width=1600&height=900&seq=back-shadow-city&orientation=landscape",
    updatedAt: "2024-09-28",
    featured: true,
  },
  {
    id: "echoes-of-time",
    title: "时光回响",
    titleEn: "Echoes of Time",
    type: "movie",
    region: "美国",
    year: 2023,
    rating: 8.2,
    popularity: 8460,
    genres: ["科幻", "剧情", "爱情"],
    director: "艾略特·里德",
    cast: ["诺亚·贝内特", "艾玛·斯隆", "詹姆斯·柯尔"],
    tagline: "如果时间可以折叠，你最想重写哪一天？",
    synopsis:
      "天体物理学家在调试一台引力波探测器时，意外接收到来自三个月后的自己发来的信号。为了改变一场即将发生的悲剧，他一次次修正过去。",
    plot: [
      "独立实验室里，天体物理学家伊森与搭档艾玛正在为引力波探测器做最后的校准。一个寻常的深夜，仪器捕捉到一段无法解释的重复信号——解码后，竟是伊森本人的声音，日期标注在九十天之后。",
      "信号里反复出现同一个词：别让她上车。伊森开始尝试改变未来，却发现每一次干预都会让信号本身发生偏移，仿佛时间是一条会反抗的河流。",
      "在第三次循环中，他终于意识到真正需要被改变的并非事件本身，而是自己长久以来对失去的恐惧。影片用克制的科幻设定，讲述了一个关于告别的温柔故事。",
    ],
    characters: [
      {
        name: "伊森·凯尔",
        actor: "诺亚·贝内特",
        role: "天体物理学家",
        description:
          "理性、专注却情感迟钝的科学家，习惯用方程解释一切，却始终无法为心里的那个空白求解。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20thoughtful%20male%20physicist%20in%20a%20dark%20shirt%20standing%20in%20a%20dim%20laboratory%2C%20cool%20blue%20and%20soft%20violet%20lighting%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-echoes-ethan&orientation=portrait"
      },
      {
        name: "艾玛·斯隆",
        actor: "艾玛·斯隆",
        role: "研究搭档",
        description:
          "实验室里最清醒的观察者，也是伊森与真实世界之间的桥梁。她相信有些答案不在数据里，而在人心里。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20an%20intelligent%20female%20scientist%20with%20short%20hair%20in%20a%20lab%20coat%2C%20soft%20blue%20key%20light%2C%20abstract%20instrument%20background%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-echoes-emma&orientation=portrait"
      },
      {
        name: "老托马斯",
        actor: "詹姆斯·柯尔",
        role: "退休教授",
        description:
          "曾提出时间折返理论的边缘学者，被学界视为异想天开，却在多年后成为伊森唯一的证人。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20an%20elderly%20retired%20professor%20with%20white%20beard%20and%20glasses%2C%20warm%20library%20lamplight%2C%20muted%20blue%20tones%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-echoes-thomas&orientation=portrait"
      }
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20movie%20poster%20of%20a%20lone%20figure%20standing%20before%20a%20giant%20glowing%20ring%20of%20light%2C%20deep%20blue%20and%20amber%20color%20grading%2C%20dreamlike%20atmosphere%2C%20professional%20film%20key%20art%2C%20high%20detail%2C%20vertical%20composition&width=600&height=900&seq=poster-echoes-time&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20dim%20laboratory%20with%20a%20glowing%20scientific%20instrument%20and%20drifting%20particles%20of%20light%2C%20cool%20blue%20palette%20with%20soft%20amber%20accents%2C%20sci%20fi%20mood%2C%20professional%20film%20photography%2C%20high%20detail%2C%20horizontal%20composition&width=1600&height=900&seq=back-echoes-time&orientation=landscape",
    updatedAt: "2024-09-20",
    featured: true,
  },
  {
    id: "silent-river",
    title: "静默之河",
    titleEn: "The Silent River",
    type: "movie",
    region: "中国大陆",
    year: 2021,
    rating: 8.8,
    popularity: 7310,
    genres: ["剧情", "家庭"],
    director: "何见山",
    cast: ["王树生", "刘玉琴", "何小满"],
    tagline: "河水从不回答，却记得每一个离开的人。",
    synopsis:
      "一位守着渡口的老人，用一整个汛期等待外出务工的儿子归来。河流见证了三代人的聚散，也见证了一个村庄的消逝。",
    plot: [
      "上游修坝之后，老渡口的水位一年比一年低。老周依旧每天把船擦得发亮，他说儿子今年一定回来。村里人都知道，那艘船已经三年没载过客人。",
      "小满是从城里回来的孙女，带着拍摄作业要记录故乡。她起初不理解爷爷的固执，直到在樟木箱底翻出一摞从未寄出的信。",
      "影片几乎没有激烈的冲突，却在一个个日常细节里，把时间与乡愁的重量沉进观众心里。结尾处，老周终于放下了船桨。",
    ],
    characters: [
      {
        name: "老周",
        actor: "王树生",
        role: "渡口船夫",
        description:
          "沉默、坚韧的老人，一生与河流为伴。他的坚持看似固执，实则是把思念安放在一个可以被等待的地方。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20weathered%20elderly%20Chinese%20boatman%20in%20simple%20clothes%20beside%20a%20river%2C%20soft%20overcast%20natural%20light%2C%20misty%20mountain%20background%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-river-laozhou&orientation=portrait"
      },
      {
        name: "小满",
        actor: "何小满",
        role: "孙女",
        description:
          "在城市长大的大学生，带着摄像机回到陌生又熟悉的故乡，逐渐读懂了长辈沉默背后的语言。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20young%20Chinese%20woman%20holding%20a%20camera%20by%20a%20riverside%20village%2C%20warm%20muted%20afternoon%20light%2C%20soft%20green%20and%20grey%20tones%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-river-xiaoman&orientation=portrait"
      },
      {
        name: "刘玉琴",
        actor: "刘玉琴",
        role: "老伴",
        description:
          "早已离世却始终活在老周叙述里的妻子。她的旧照片与旧信件，构成影片最柔软的部分。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20kind%20elderly%20Chinese%20woman%20seen%20through%20a%20soft%20nostalgic%20filter%2C%20warm%20sepia%20and%20blue%20tones%2C%20old%20photograph%20feeling%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-river-wife&orientation=portrait"
      }
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20movie%20poster%20of%20a%20small%20wooden%20boat%20on%20a%20calm%20misty%20river%20at%20dawn%2C%20muted%20blue%20and%20soft%20green%20palette%2C%20quiet%20melancholic%20atmosphere%2C%20professional%20film%20key%20art%2C%20high%20detail%2C%20vertical%20composition&width=600&height=900&seq=poster-silent-river&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20serene%20river%20flowing%20through%20misty%20mountains%20at%20sunrise%2C%20muted%20blue%20green%20palette%2C%20calm%20poetic%20drama%20mood%2C%20professional%20film%20photography%2C%20high%20detail%2C%20horizontal%20composition&width=1600&height=900&seq=back-silent-river&orientation=landscape",
    updatedAt: "2024-08-15",
  },
  {
    id: "the-last-letter",
    title: "最后一封信",
    titleEn: "The Last Letter",
    type: "movie",
    region: "日本",
    year: 2024,
    rating: 8.4,
    popularity: 6890,
    genres: ["爱情", "剧情"],
    director: "小林悠介",
    cast: ["佐藤美咲", "中村凛", "高桥和也"],
    tagline: "有些话，写下来比说出来更容易。",
    synopsis:
      "旧书店店员在整理一批寄不出的信件时，发现一封写给十年后自己的信。循着字迹，她找到了信中那个从未出现的收信人。",
    plot: [
      "濑户内海边的小镇上，有一家只收不卖旧信的书店。店员千夏的工作，是替人们保管那些没能送达的心意。一封尘封十年的信件，被夹在一本旧诗集里送到她手上。",
      "信的开头写着：致十年后的我。千夏循着信中提到的地名与人名，找到了当年写信的少年，却发现他早已搬离，只留下满墙无人认领的明信片。",
      "当两人终于在海边的旧灯塔下重逢，千夏才明白，有些信之所以寄不出去，是因为它们一直在等一个愿意拆开它的人。",
    ],
    characters: [
      {
        name: "千夏",
        actor: "佐藤美咲",
        role: "旧书店店员",
        description:
          "安静细腻的姑娘，习惯用文字而非言语表达情感。她相信每一封信都有它注定要抵达的时间。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20gentle%20young%20Japanese%20woman%20holding%20an%20old%20letter%20in%20a%20warm%20bookshop%2C%20soft%20window%20light%2C%20muted%20amber%20and%20blue%20tones%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-letter-chinatsu&orientation=portrait"
      },
      {
        name: "凛",
        actor: "中村凛",
        role: "灯塔守夜人",
        description:
          "十年前写下乡愁的少年，如今成了沉默的灯塔守夜人。他把没说出口的话，都留在了潮水里。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20reserved%20young%20Japanese%20man%20in%20a%20coat%20standing%20by%20a%20seaside%20lighthouse%2C%20cool%20blue%20dusk%20light%2C%20soft%20melancholic%20mood%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-letter-rin&orientation=portrait"
      },
      {
        name: "和也",
        actor: "高桥和也",
        role: "书店主人",
        description:
          "经营旧信书店三十年的老人，收藏着整座小镇的悲欢。他是千夏了解过去最温和的入口。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20kind%20elderly%20Japanese%20bookseller%20with%20glasses%20surrounded%20by%20old%20books%2C%20warm%20lamp%20light%2C%20cozy%20sepia%20and%20blue%20tones%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-letter-kazuya&orientation=portrait"
      }
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20drama%20movie%20poster%20of%20a%20hand%20holding%20an%20old%20sealed%20letter%20against%20a%20seaside%20sunset%2C%20warm%20amber%20and%20soft%20blue%20grading%2C%20gentle%20nostalgic%20atmosphere%2C%20professional%20film%20key%20art%2C%20high%20detail%2C%20vertical%20composition&width=600&height=900&seq=poster-last-letter&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20quiet%20Japanese%20seaside%20town%20with%20a%20lighthouse%20at%20dusk%2C%20warm%20amber%20and%20cool%20blue%20grading%2C%20tender%20romantic%20drama%20mood%2C%20professional%20film%20photography%2C%20high%20detail%2C%20horizontal%20composition&width=1600&height=900&seq=back-last-letter&orientation=landscape",
    updatedAt: "2024-09-30",
    featured: true,
  },
  {
    id: "blade-monarch",
    title: "剑影王朝",
    titleEn: "Blade Monarch",
    type: "tv",
    region: "中国大陆",
    year: 2024,
    rating: 8.3,
    popularity: 10540,
    genres: ["古装", "武侠", "权谋"],
    director: "沈墨白",
    cast: ["萧云澈", "白筱宁", "陆铮", "程婉"],
    tagline: "刀锋之下，没有真正的赢家。",
    synopsis:
      "乱世末年，一位隐姓埋名的剑客被卷入王朝更迭的漩涡。他手握天下最快的剑，却要用它守护一个注定破碎的诺言。",
    plot: [
      "北境战事吃紧，朝廷却仍在争权夺利。曾名震江湖的剑客谢无衣选择归隐，以铁匠的身份藏于市井，直到一名身负重伤的少女敲开了他的门。",
      "少女带来的一枚令牌，牵出十六年前那场血洗师门的旧案。为查明真相，谢无衣被迫重返庙堂与江湖之间，成为各方势力争夺的棋子。",
      "随着权力棋盘被彻底打乱，他逐渐发现，真正的敌人并不在对面，而在每个人都想坐上的那把椅子上。全剧以凌厉的武打设计与缜密的权谋推演，勾勒出一个时代的兴衰。",
    ],
    characters: [
      {
        name: "谢无衣",
        actor: "萧云澈",
        role: "隐世剑客",
        description:
          "曾是天下闻名的剑客，如今只愿做一名铁匠。他的剑很快，心却很慢，重情重义到近乎自苦。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20calm%20ancient%20Chinese%20swordsman%20in%20dark%20flowing%20robes%20holding%20a%20sheathed%20sword%2C%20dramatic%20blue%20and%20amber%20lighting%2C%20misty%20mountain%20background%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-blade-xie&orientation=portrait"
      },
      {
        name: "白筱宁",
        actor: "白筱宁",
        role: "将门之女",
        description:
          "生于军中的贵族少女，性情果决。她带着旧案的唯一物证而来，也带着改变谢无衣命运的决心。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20resolute%20ancient%20Chinese%20young%20woman%20in%20elegant%20light%20armor%2C%20cool%20blue%20and%20warm%20accent%20lighting%2C%20palace%20corridor%20background%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-blade-bai&orientation=portrait"
      },
      {
        name: "陆铮",
        actor: "陆铮",
        role: "权臣",
        description:
          "深谙朝堂规则的谋士，看似温文尔雅，实则为达目的不择手段。他是谢无衣最危险的盟友。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20shrewd%20ancient%20Chinese%20court%20strategist%20in%20ornate%20dark%20robes%2C%20candlelit%20palace%20background%2C%20cool%20blue%20and%20amber%20tones%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-blade-lu&orientation=portrait"
      }
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20wuxia%20drama%20poster%20of%20a%20swordsman%20silhouette%20against%20a%20moonlit%20battlefield%2C%20deep%20blue%20and%20fiery%20orange%20color%20grading%2C%20epic%20dramatic%20atmosphere%2C%20professional%20film%20key%20art%2C%20high%20detail%2C%20vertical%20composition&width=600&height=900&seq=poster-blade-monarch&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20an%20ancient%20Chinese%20palace%20courtyard%20at%20night%20with%20torches%20and%20drifting%20mist%2C%20deep%20blue%20and%20warm%20amber%20grading%2C%20epic%20historical%20drama%20mood%2C%20professional%20film%20photography%2C%20high%20detail%2C%20horizontal%20composition&width=1600&height=900&seq=back-blade-monarch&orientation=landscape",
    updatedAt: "2024-09-25",
    featured: true,
  },
  {
    id: "city-lights",
    title: "都市浮光",
    titleEn: "City Lights",
    type: "tv",
    region: "中国大陆",
    year: 2023,
    rating: 7.9,
    popularity: 9120,
    genres: ["都市", "情感"],
    director: "安以宁",
    cast: ["方知夏", "宋亦扬", "林晚", "裴叙"],
    tagline: "在这座不眠的城市里，每个人都在寻找自己的灯。",
    synopsis:
      "四位身处不同职业的年轻人，在同一栋写字楼里各自奔波。加班的深夜、交错的电梯、擦肩而过的瞬间，拼出一幅当代都市的情感图景。",
    plot: [
      "二十八岁那年，设计师方知夏刚经历了一场失败的创业。她带着仅剩的积蓄搬进老城区一间小公寓，在同一栋楼里，遇见了形形色色的邻居。",
      "写代码写到凌晨的程序员、白天做主播夜晚打零工的女孩、表面光鲜却负债累累的销售……他们的故事看似无关，却因一场突如其来的停电交织在一起。",
      "剧集用大量生活细节堆叠出真实的都市质感，不回避疲惫，也不吝啬温柔。最终，每个人都在这座城市里，找到了属于自己的那一点微光。",
    ],
    characters: [
      {
        name: "方知夏",
        actor: "方知夏",
        role: "独立设计师",
        description:
          "经历过创业失败却依然坚持自我表达的设计师，倔强、敏锐，习惯把情绪画进草图里。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20stylish%20young%20Chinese%20female%20designer%20in%20a%20modern%20studio%2C%20cool%20blue%20window%20light%20with%20warm%20accent%2C%20urban%20apartment%20background%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-lights-zhixia&orientation=portrait"
      },
      {
        name: "宋亦扬",
        actor: "宋亦扬",
        role: "程序员",
        description:
          "作息颠倒的深夜工作者，嘴上说着佛系，实际上对生活依然怀抱期待。他的温柔藏在细节里。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20tired%20young%20Chinese%20male%20programmer%20with%20glasses%20lit%20by%20monitor%20glow%2C%20cool%20blue%20tones%20with%20warm%20lamp%2C%20night%20office%20background%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-lights-yiyang&orientation=portrait"
      },
      {
        name: "林晚",
        actor: "林晚",
        role: "深夜主播",
        description:
          "白天做两份兼职、夜晚在直播间里唱歌的女孩。她乐观得近乎逞强，是楼里最亮的那盏灯。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20cheerful%20young%20Chinese%20woman%20sitting%20in%20a%20cozy%20room%20lit%20by%20warm%20string%20lights%2C%20cool%20blue%20background%20with%20amber%20accents%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-lights-linwan&orientation=portrait"
      }
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20urban%20drama%20poster%20of%20a%20young%20woman%20standing%20by%20a%20rain%20streaked%20window%20overlooking%20city%20lights%20at%20night%2C%20deep%20blue%20and%20warm%20orange%20grading%2C%20contemplative%20mood%2C%20professional%20film%20key%20art%2C%20high%20detail%2C%20vertical%20composition&width=600&height=900&seq=poster-city-lights&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20modern%20city%20skyline%20at%20blue%20hour%20with%20glowing%20office%20windows%2C%20cool%20blue%20and%20warm%20orange%20grading%2C%20urban%20contemporary%20drama%20mood%2C%20professional%20film%20photography%2C%20high%20detail%2C%20horizontal%20composition&width=1600&height=900&seq=back-city-lights&orientation=landscape",
    updatedAt: "2024-09-12",
  },
  {
    id: "deep-blue-case",
    title: "深蓝档案",
    titleEn: "Deep Blue Case",
    type: "web",
    region: "中国大陆",
    year: 2024,
    rating: 8.5,
    popularity: 8730,
    genres: ["悬疑", "刑侦", "犯罪"],
    director: "陆沉舟",
    cast: ["江砚", "温以宁", "许柏舟"],
    tagline: "档案不会说谎，说谎的是翻开它的人。",
    synopsis:
      "刑事技术室的分析师，从一批被封存的旧物证中，重建出一桩长达二十年的悬案。真相越清晰，危险就越近。",
    plot: [
      "在市公安局尘封多年的物证仓库里，分析师江砚接手了一项特殊任务：重新梳理一批因技术限制未能侦破的悬案。第一件物证，是一枚被雨水浸泡过的纽扣。",
      "凭借新的痕检技术，江砚重建出案发当晚的时间线，却发现所有证据都指向一位早已退休的资深警员。她必须在同事的质疑与内部的压力中，坚持自己的判断。",
      "短剧以每集一案、末集收线的结构推进，节奏紧凑。当最后的档案被打开，观众才明白，有些真相之所以被深藏，是因为它太过沉重。",
    ],
    characters: [
      {
        name: "江砚",
        actor: "江砚",
        role: "痕检分析师",
        description:
          "理性到近乎冷酷的技术派，只相信证据链条。她的执拗来自对每一个无名受害者的尊重。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20focused%20young%20Chinese%20female%20forensic%20analyst%20wearing%20gloves%20in%20a%20lab%2C%20cool%20blue%20lighting%2C%20evidence%20room%20background%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-deep-jiangyan&orientation=portrait"
      },
      {
        name: "温以宁",
        actor: "温以宁",
        role: "重案组长",
        description:
          "雷厉风行的一线刑警，与江砚从互相看不惯到并肩作战。她代表的是经验与直觉的力量。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20tough%20young%20Chinese%20female%20police%20officer%20in%20plainclothes%2C%20cool%20blue%20tone%20with%20warm%20accent%2C%20city%20night%20background%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-deep-wenyining&orientation=portrait"
      },
      {
        name: "许柏舟",
        actor: "许柏舟",
        role: "退休警员",
        description:
          "被证据指向的旧案经办人，沉默而复杂。他究竟是无辜的旁观者，还是被时间掩埋的关键？",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20troubled%20retired%20Chinese%20police%20officer%20with%20grey%20hair%2C%20dim%20blue%20lighting%2C%20shadowy%20corridor%20background%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-deep-xubaizhou&orientation=portrait"
      }
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20investigation%20poster%20of%20a%20forensic%20evidence%20board%20with%20photos%20and%20red%20thread%2C%20deep%20blue%20and%20warm%20orange%20grading%2C%20tense%20mystery%20atmosphere%2C%20professional%20film%20key%20art%2C%20high%20detail%2C%20vertical%20composition&width=600&height=900&seq=poster-deep-blue-case&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20dark%20forensic%20laboratory%20with%20blue%20screens%20and%20scattered%20evidence%2C%20deep%20blue%20and%20warm%20amber%20grading%2C%20tense%20investigative%20mood%2C%20professional%20film%20photography%2C%20high%20detail%2C%20horizontal%20composition&width=1600&height=900&seq=back-deep-blue-case&orientation=landscape",
    updatedAt: "2024-09-29",
    featured: true,
  },
  {
    id: "starlight-promise",
    title: "星光之约",
    titleEn: "Starlight Promise",
    type: "web",
    region: "韩国",
    year: 2023,
    rating: 8.0,
    popularity: 7640,
    genres: ["青春", "爱情", "校园"],
    director: "金智勋",
    cast: ["韩瑞妍", "李道贤", "朴涩琪"],
    tagline: "我们约好，谁先看到流星，就替对方许愿。",
    synopsis:
      "天文社的两名高中生在一次流星雨观测中约定，无论将来身在何处，都要在同一片星空下重逢。十年后，命运给了他们第二次机会。",
    plot: [
      "高三那年的秋天，天文社只剩最后两名成员。内向的瑞妍与转学生道贤一起守着一台老旧的望远镜，看遍了这个城市所有的夜空。",
      "毕业前夕，两人约定十年后在母校的天文台重逢。可道贤因为家庭变故不告而别，只留下一本写满观测记录的笔记本。",
      "十年后，已经成为天文台研究员的瑞妍，在一次例行观测中收到了匿名投稿。投稿里的星图坐标，正是他们当年约定的暗号。",
    ],
    characters: [
      {
        name: "韩瑞妍",
        actor: "韩瑞妍",
        role: "天文社成员",
        description:
          "安静却执着的星空爱好者，她把等待变成了一种习惯，也把观测笔记保存了整整十年。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20quiet%20young%20Korean%20female%20student%20standing%20under%20starlight%20beside%20a%20telescope%2C%20deep%20blue%20night%20tones%20with%20soft%20warm%20accents%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-star-seoyeon&orientation=portrait"
      },
      {
        name: "李道贤",
        actor: "李道贤",
        role: "转学生",
        description:
          "外表随和、内心藏着许多心事的少年。他的不辞而别并非冷漠，而是不得已的告别。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20thoughtful%20young%20Korean%20male%20student%20holding%20a%20notebook%20under%20a%20night%20sky%2C%20cool%20blue%20tones%20with%20warm%20lamp%20glow%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-star-dohyun&orientation=portrait"
      },
      {
        name: "朴涩琪",
        actor: "朴涩琪",
        role: "同社团友",
        description:
          "活泼开朗的社团元老，是两人的见证者。她总说，观测星空的人，心里都住着一颗不肯落下的星。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20cheerful%20young%20Korean%20woman%20in%20a%20school%20uniform%20with%20a%20warm%20smile%2C%20soft%20blue%20and%20amber%20lighting%2C%20night%20campus%20background%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-star-seulki&orientation=portrait"
      }
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20youth%20romance%20poster%20of%20two%20silhouettes%20sitting%20on%20a%20rooftop%20under%20a%20meteor%20shower%2C%20deep%20blue%20and%20warm%20amber%20grading%2C%20dreamy%20nostalgic%20atmosphere%2C%20professional%20film%20key%20art%2C%20high%20detail%2C%20vertical%20composition&width=600&height=900&seq=poster-starlight-promise&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20starry%20night%20sky%20above%20a%20quiet%20school%20rooftop%20with%20a%20telescope%2C%20deep%20blue%20and%20warm%20amber%20grading%2C%20romantic%20youth%20drama%20mood%2C%20professional%20film%20photography%2C%20high%20detail%2C%20horizontal%20composition&width=1600&height=900&seq=back-starlight-promise&orientation=landscape",
    updatedAt: "2024-08-22",
  },
  {
    id: "mountain-and-sea",
    title: "山海归途",
    titleEn: "The Long Way Home",
    type: "tv",
    region: "中国大陆",
    year: 2022,
    rating: 8.7,
    popularity: 7010,
    genres: ["家庭", "剧情", "生活"],
    director: "周长青",
    cast: ["赵山河", "孙玉兰", "赵启明", "许梅"],
    tagline: "走得再远，饭桌上总有一双筷子等着你。",
    synopsis:
      "一个在外打拼多年的儿子，因为母亲的一场病回到大山深处的老家。三代人的隔阂与牵挂，在一顿顿家常饭里慢慢和解。",
    plot: [
      "赵启明在南方城市做了十几年生意，接电话时总说忙。直到妹妹发来一张母亲住院的照片，他才匆匆踏上返乡的长途车。",
      "老家的老屋、旧灶、后山的橘子林，每一样都在提醒他离开得有多久。父亲沉默寡言，妹妹心怀怨气，母亲的病成了横在全家人之间的一道墙。",
      "剧集不刻意煽情，而是用一餐一饭、一草一木，慢慢缝合被时间撕开的裂痕。当启明最终决定留在家乡，观众也跟着完成了一次归途。",
    ],
    characters: [
      {
        name: "赵启明",
        actor: "赵启明",
        role: "返乡长子",
        description:
          "在外闯荡多年、事业起落的生意人。他的愧疚与倔强，是许多离乡者的缩影。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20middle%20aged%20Chinese%20man%20in%20a%20simple%20jacket%20standing%20in%20a%20rural%20mountain%20village%2C%20soft%20overcast%20natural%20light%2C%20muted%20green%20and%20blue%20tones%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-mountain-qiming&orientation=portrait"
      },
      {
        name: "孙玉兰",
        actor: "孙玉兰",
        role: "母亲",
        description:
          "操劳一生的农村母亲，话不多，却把所有的爱都做进了饭菜里。她的病让一家人重新聚拢。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20kind%20elderly%20Chinese%20rural%20mother%20sitting%20by%20a%20traditional%20kitchen%20stove%2C%20warm%20soft%20light%2C%20muted%20amber%20and%20green%20tones%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-mountain-yulan&orientation=portrait"
      },
      {
        name: "赵山河",
        actor: "赵山河",
        role: "父亲",
        description:
          "一生守着后山果园的老父亲，与儿子观念冲突不断。他的沉默，是最笨拙的关心。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20stoic%20elderly%20Chinese%20farmer%20with%20weathered%20face%20in%20an%20orange%20orchard%2C%20soft%20green%20and%20blue%20tones%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-mountain-shanhe&orientation=portrait"
      }
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20family%20drama%20poster%20of%20a%20rural%20Chinese%20house%20nestled%20in%20misty%20mountains%20at%20dusk%20with%20a%20warm%20lit%20window%2C%20muted%20blue%20green%20and%20amber%20grading%2C%20heartwarming%20mood%2C%20professional%20film%20key%20art%2C%20high%20detail%2C%20vertical%20composition&width=600&height=900&seq=poster-mountain-sea&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20terraced%20rice%20fields%20and%20a%20mountain%20village%20in%20soft%20morning%20mist%2C%20muted%20green%20and%20blue%20palette%20with%20warm%20sunrise%20accents%2C%20peaceful%20rural%20drama%20mood%2C%20professional%20film%20photography%2C%20high%20detail%2C%20horizontal%20composition&width=1600&height=900&seq=back-mountain-sea&orientation=landscape",
    updatedAt: "2024-07-30",
  },
  {
    id: "neon-hunter",
    title: "霓虹猎手",
    titleEn: "Neon Hunter",
    type: "web",
    region: "日本",
    year: 2024,
    rating: 8.1,
    popularity: 7920,
    genres: ["科幻", "动作", "悬疑"],
    director: "山田苍介",
    cast: ["相叶凌", "藤崎遥", "桐生一"],
    tagline: "在被数据统治的城市里，记忆是最昂贵的货币。",
    synopsis:
      "近未来的东京，一名退役的“记忆猎手”被雇去追回一段被人窃取的记忆。追查途中，他发现自己才是整件事的核心。",
    plot: [
      "二〇四七年，记忆可以被提取、交易，也可以被窃取。凌曾是圈内最顶尖的记忆猎手，如今只靠接些零散委托度日。",
      "一份加密的记忆片段将他引向城市的底层网络。在那里，他遇见了自称是他妹妹的女孩，可他的记忆里，从未有过这个人。",
      "当他一层层剥开真相，才发现自己被人为删改过。剧集以强烈的霓虹视觉与高密度动作场面，探讨记忆与身份的边界。",
    ],
    characters: [
      {
        name: "相叶凌",
        actor: "相叶凌",
        role: "记忆猎手",
        description:
          "身手利落、沉默寡言的退役猎手。他追寻真相的动力，源于一个连自己都不确定是否真实的记忆。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20cool%20cyberpunk%20male%20hunter%20in%20a%20futuristic%20jacket%20surrounded%20by%20neon%20signs%2C%20deep%20blue%20and%20hot%20orange%20lighting%2C%20rainy%20city%20background%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-neon-ryo&orientation=portrait"
      },
      {
        name: "藤崎遥",
        actor: "藤崎遥",
        role: "神秘少女",
        description:
          "自称是凌妹妹的少女，掌握着城市数据网络的秘密。她的出现，彻底打乱了凌的所有认知。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20mysterious%20cyberpunk%20young%20woman%20with%20glowing%20accents%20in%20a%20neon%20alley%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-neon-haruka&orientation=portrait"
      },
      {
        name: "桐生一",
        actor: "桐生一",
        role: "情报贩子",
        description:
          "游走于灰色地带的情报商，谁出得起价钱就把消息卖给谁。他既是凌的线人，也是潜在的威胁。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20shady%20cyberpunk%20male%20informant%20with%20tattoos%20in%20a%20neon%20bar%2C%20deep%20blue%20and%20hot%20orange%20lighting%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-neon-ichiro&orientation=portrait"
      }
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20cyberpunk%20sci%20fi%20poster%20of%20a%20hooded%20hunter%20silhouette%20against%20a%20rainy%20neon%20megacity%2C%20deep%20blue%20and%20hot%20orange%20grading%2C%20high%20tech%20tense%20atmosphere%2C%20professional%20film%20key%20art%2C%20high%20detail%2C%20vertical%20composition&width=600&height=900&seq=poster-neon-hunter&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20futuristic%20neon%20lit%20Tokyo%20street%20at%20night%20with%20rain%20and%20holograms%2C%20deep%20blue%20and%20hot%20orange%20grading%2C%20cyberpunk%20atmosphere%2C%20professional%20film%20photography%2C%20high%20detail%2C%20horizontal%20composition&width=1600&height=900&seq=back-neon-hunter&orientation=landscape",
    updatedAt: "2024-09-18",
  },
  {
    id: "the-cook-of-tang",
    title: "唐宫小厨娘",
    titleEn: "The Cook of Tang",
    type: "tv",
    region: "中国大陆",
    year: 2024,
    rating: 7.8,
    popularity: 6250,
    genres: ["古装", "美食", "轻喜剧"],
    director: "苏念卿",
    cast: ["花未晚", "谢知行", "柳月华"],
    tagline: "一道菜，可以暖一桌人，也可以定一场风波。",
    synopsis:
      "误入大唐的现代厨娘，凭一手好菜在宫廷御膳房站稳脚跟。美食、宫斗与轻喜感交织，讲一个关于热爱与成长的故事。",
    plot: [
      "一觉醒来，美食博主花未晚发现自己身处长安城，还莫名其妙成了御膳房最底层的帮厨。她做的第一道胡椒饼，就让挑食的小公主吃了个精光。",
      "凭着对食材的理解与天马行空的创意，她一路从帮厨做到掌勺，也卷入了膳房与权贵之间的明争暗斗。",
      "与冷面侍卫谢知行从互怼到并肩，是这部剧最轻松的调味。全剧用一道道美食串起人物的成长,也把盛唐的烟火气呈现在观众眼前。",
    ],
    characters: [
      {
        name: "花未晚",
        actor: "花未晚",
        role: "御膳房厨娘",
        description:
          "来自现代的美食博主，乐观、机灵、不按常理出牌。她的菜和她的性格一样，总能给人惊喜。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20lively%20ancient%20Chinese%20young%20female%20cook%20in%20elegant%20hanfu%20holding%20a%20ladle%20in%20a%20warm%20kitchen%2C%20soft%20amber%20and%20blue%20lighting%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-cook-hua&orientation=portrait"
      },
      {
        name: "谢知行",
        actor: "谢知行",
        role: "宫廷侍卫",
        description:
          "冷面寡言却心怀正气的年轻侍卫，负责宫中安危。他嘴上嫌弃花未晚胡闹，行动上却处处护着她。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20handsome%20ancient%20Chinese%20palace%20guard%20in%20armor%20with%20a%20stern%20expression%2C%20candlelit%20palace%20background%2C%20cool%20blue%20and%20amber%20tones%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-cook-xie&orientation=portrait"
      },
      {
        name: "柳月华",
        actor: "柳月华",
        role: "掌勺姑姑",
        description:
          "御膳房资历最深的掌勺，规矩多、脾气硬，却最惜才。她与花未晚的关系从对立走向惺惺相惜。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20strict%20elderly%20ancient%20Chinese%20female%20head%20cook%20in%20hanfu%2C%20warm%20kitchen%20interior%20lighting%2C%20amber%20and%20muted%20blue%20tones%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-cook-liu&orientation=portrait"
      }
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20comedy%20drama%20poster%20of%20a%20steaming%20banquet%20table%20in%20a%20Tang%20dynasty%20palace%20hall%2C%20warm%20amber%20and%20teal%20blue%20grading%2C%20cheerful%20festive%20atmosphere%2C%20professional%20film%20key%20art%2C%20high%20detail%2C%20vertical%20composition&width=600&height=900&seq=poster-cook-tang&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20Tang%20dynasty%20imperial%20kitchen%20with%20steaming%20pots%20and%20warm%20lanterns%2C%20rich%20amber%20and%20cool%20blue%20grading%2C%20lively%20historical%20comedy%20mood%2C%20professional%20film%20photography%2C%20high%20detail%2C%20horizontal%20composition&width=1600&height=900&seq=back-cook-tang&orientation=landscape",
    updatedAt: "2024-09-05",
  },
  {
    id: "code-name-orchid",
    title: "代号幽兰",
    titleEn: "Code Name Orchid",
    type: "web",
    region: "中国大陆",
    year: 2023,
    rating: 8.4,
    popularity: 8150,
    genres: ["谍战", "悬疑", "年代"],
    director: "贺云开",
    cast: ["沈幽兰", "顾南舟", "孟廷之"],
    tagline: "在最危险的地方，做一个最普通的人。",
    synopsis:
      "一九四三年的上海，一位潜伏在敌营深处的译电员，用一份份冰冷的电报，改写着一场没有硝烟的战争。",
    plot: [
      "沈幽兰是敌人情报机关里最不起眼的一名译电员。她每天准时上班、泡茶、整理文件，没有人知道她的真实身份。",
      "当一份关于“幽兰”的抓捕名单被摆上桌面，她必须在暴露前，把最后一份情报送出去。时间，成了她最奢侈的东西。",
      "剧集以极克制的表演与密闭空间的调度，营造出窒息的悬疑感。每一次心跳加速，都可能是一次告别。",
    ],
    characters: [
      {
        name: "沈幽兰",
        actor: "沈幽兰",
        role: "潜伏译电员",
        description:
          "表面温顺服从、内心坚韧冷静的译电员。她把所有的情绪都藏在一张毫无破绽的平静面孔之下。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20an%20elegant%20vintage%201940s%20Chinese%20female%20typist%20in%20a%20dim%20office%2C%20cool%20blue%20and%20warm%20lamp%20lighting%2C%20mysterious%20calm%20mood%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-orchid-shen&orientation=portrait"
      },
      {
        name: "顾南舟",
        actor: "顾南舟",
        role: "联络人",
        description:
          "小心翼翼却又果敢的地下联络员，是幽兰在黑暗中最可靠的伙伴。他总把危险留给自己。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20wary%20vintage%201940s%20Chinese%20young%20man%20in%20a%20trench%20coat%20in%20a%20foggy%20street%2C%20cool%20blue%20and%20amber%20tones%2C%20tense%20mood%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-orchid-gu&orientation=portrait"
      },
      {
        name: "孟廷之",
        actor: "孟廷之",
        role: "情报处长",
        description:
          "老练多疑的敌营情报负责人，善于从细节中察觉异常。他是幽兰最危险的对手。",
        image:
          "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20suspicious%20vintage%201940s%20older%20Chinese%20intelligence%20officer%20in%20a%20dark%20suit%2C%20dim%20blue%20lighting%2C%20office%20background%2C%20professional%20film%20still%2C%20high%20detail%2C%20vertical%20portrait%20composition&width=500&height=600&seq=char-orchid-meng&orientation=portrait"
      }
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20spy%20thriller%20poster%20of%20a%20vintage%201940s%20Shanghai%20night%20street%20with%20neon%20signs%20and%20a%20woman%20in%20a%20qipao%2C%20deep%20blue%20and%20warm%20orange%20grading%2C%20tense%20noir%20atmosphere%2C%20professional%20film%20key%20art%2C%20high%20detail%2C%20vertical%20composition&width=600&height=900&seq=poster-code-orchid&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20foggy%20vintage%201940s%20Shanghai%20street%20at%20night%20with%20neon%20signs%20and%20old%20cars%2C%20deep%20blue%20and%20warm%20orange%20grading%2C%20noir%20spy%20drama%20mood%2C%20professional%20film%20photography%2C%20high%20detail%2C%20horizontal%20composition&width=1600&height=900&seq=back-code-orchid&orientation=landscape",
    updatedAt: "2024-08-08",
  }
];